import api from './api';

export interface AppException {
  id: number;
  fingerprint: string;
  exception_type: string;
  exception_message: string | null;
  traceback: string | null;
  endpoint: string | null;
  method: string | null;
  http_status: number | null;
  user_id: number | null;
  first_seen_at: string;
  last_seen_at: string;
  count: number;
  is_system_exception: boolean;
  agent_status: string | null;
}

export interface ExceptionFix {
  id: number;
  fingerprint: string;
  pr_url: string | null;
  pr_number: number | null;
  pr_status: string;
  fix_summary: string | null;
  created_at: string;
}

export interface ExceptionsListResponse {
  total: number;
  page: number;
  page_size: number;
  items: AppException[];
}

const BASE = '/api/v1/admin/exceptions';

export const exceptionsService = {
  list: async (params?: {
    page?: number;
    page_size?: number;
    exception_type?: string;
    agent_status?: string;
    min_count?: number;
  }): Promise<ExceptionsListResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.set('page', String(params.page));
    if (params?.page_size) queryParams.set('page_size', String(params.page_size));
    if (params?.exception_type) queryParams.set('exception_type', params.exception_type);
    if (params?.agent_status) queryParams.set('agent_status', params.agent_status);
    if (params?.min_count) queryParams.set('min_count', String(params.min_count));
    const qs = queryParams.toString();
    return api.request<ExceptionsListResponse>(`${BASE}${qs ? `?${qs}` : ''}`);
  },

  get: async (fingerprint: string): Promise<AppException> => {
    return api.request<AppException>(`${BASE}/${fingerprint}`);
  },

  update: async (fingerprint: string, updates: { agent_status?: string | null; is_system_exception?: boolean }): Promise<AppException> => {
    return api.request<AppException>(`${BASE}/${fingerprint}`, {
      method: 'PATCH',
      body: JSON.stringify(updates),
    });
  },

  delete: async (fingerprint: string): Promise<void> => {
    return api.request<void>(`${BASE}/${fingerprint}`, { method: 'DELETE' });
  },

  getFixes: async (fingerprint: string): Promise<ExceptionFix[]> => {
    return api.request<ExceptionFix[]>(`${BASE}/${fingerprint}/fixes`);
  },
};
